import { FormSearchMultipleSelection } from '@shared/components';

import type { ExamEventRegistrationStatus } from '../../type';

const REGISTRATION_STATUS_OPTIONS: {
  label: string;
  value: ExamEventRegistrationStatus;
}[] = [
  { label: 'เปิดรับสมัคร', value: 'OPEN_FOR_REGISTRATION' },
  { label: 'ปิดรับสมัครชั่วคราว', value: 'TEMPORARILY_CLOSED' },
  { label: 'ปิดรับสมัคร', value: 'REGISTRATION_CLOSED' },
  { label: 'รอบสอบเต็ม', value: 'SESSION_FULL' },
  { label: 'ยกเลิกรอบสอบ', value: 'CANCELED' },
];

interface RegistrationStatusSearchSelectionProps {
  name: string;
  value: ExamEventRegistrationStatus[];
}

export default function RegistrationStatusSearchSelection(
  props: Readonly<RegistrationStatusSearchSelectionProps>,
) {
  const { name, value } = props;

  return (
    <FormSearchMultipleSelection
      options={REGISTRATION_STATUS_OPTIONS}
      label='สถานะการรับสมัคร'
      name={name}
      sx={{ width: '100%' }}
      slotProps={{
        input: { placeholder: value.length === 0 ? 'แสดงทั้งหมด' : '' },
      }}
    />
  );
}
